export const lbCardWidth = "260px";
export const extraLargeMaxWidth = "1180px";
